import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { Link } from 'react-router-dom';

import sharedStyle from '../style.module.less';
import style from './style.module.less';

export const LabelBatchSubscriptionLimitError = ({ modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <React.Fragment>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage
          defaultMessage='Subscription limit reached'
          description='batchProcessingModal.subscriptionLimitError'
          id='La3XXF'
        />
      </ModalHeader>
      <ModalBody className={classnames(sharedStyle['batch-processing-modal'], style['subscription-limit-error-modal-body'])}>
        <div className={style['error-message']}>
          <FormattedMessage
            defaultMessage='This batch would exceed your subscription limit for this billing period. To continue shipping before your billing period resets, please upgrade your subscription. You may do so <a>here</a>.'
            description='Error message for subscription limit reached when processing a batch'
            id='QxDNUd'
            values={{
              a: (chunks) => <Link to='/settings/payments'>{chunks}</Link>,
            }}
          />
        </div>
      </ModalBody>
    </React.Fragment>
  );
};

LabelBatchSubscriptionLimitError.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
